import { Hash } from "viem";
import { NETWORK_TO_BEBOP_CONTRACT_ADDRESS_MAP, VALID_APPROVAL_SPENDER } from "../../config/consts";
import { ApprovalStore } from "../../store/approvals/ApprovalsStore";
import { GlobalStore } from "../../store/global/GlobalStore";
import { isBestQuotePmm } from "../../utils/quoteUtils";

export const useApprovalTarget = (): Hash | undefined => {
  const { quote, network } = GlobalStore.useState(s => {
    return { quote: s.quote, network: s.network };
  });
  const approvalTarget = ApprovalStore.useState(s => s.approvalTarget);

  if (approvalTarget) {
    return approvalTarget;
  }

  if (quote) {
    return isBestQuotePmm(quote.routeType)
      ? NETWORK_TO_BEBOP_CONTRACT_ADDRESS_MAP[network.id]
      : VALID_APPROVAL_SPENDER;
  }

  return undefined;
};

// Non-hook version of useApprovalTarget

export const getApprovalTarget = (): Hash | undefined => {
  const quote = GlobalStore.getRawState().quote;
  const network = GlobalStore.getRawState().network;
  const approvalTarget = ApprovalStore.getRawState().approvalTarget;

  if (approvalTarget) {
    return approvalTarget;
  }

  if (quote) {
    return isBestQuotePmm(quote.routeType)
      ? NETWORK_TO_BEBOP_CONTRACT_ADDRESS_MAP[network.id]
      : VALID_APPROVAL_SPENDER;
  }

  return undefined;
};
